import { Trophy, Clock, HeartPulse, Users, ArrowRightCircle, Activity } from "lucide-react";
export const Idrottsforening = () => {
  const features = [{
    icon: Trophy,
    title: "Erfaren lagläkare",
    description: "Specialistkompetens inom allmänmedicin"
  }, {
    icon: Clock,
    title: "Tillgänglig 24/7",
    description: "Alltid redo när ni behöver oss"
  }, {
    icon: HeartPulse,
    title: "Omfattande vårdnätverk",
    description: "Brett nätverk av specialister inom idrottsmedicin"
  }];
  return <section className="py-16 md:py-24 bg-white relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-primary/5 to-transparent" />
        <div className="absolute -left-40 top-40 w-80 h-80 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute -right-40 bottom-40 w-80 h-80 bg-primary/10 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-6 md:px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16 space-y-6">
          <div className="inline-flex items-center justify-center gap-3 mb-4">
            <Activity className="w-8 h-8 text-primary-foreground" />
            <h2 className="text-3xl md:text-5xl font-light text-primary-foreground tracking-tight">
              IDROTTSFÖRENING
            </h2>
          </div>
          <p className="text-xl md:text-2xl text-primary-foreground font-medium">
            Har du en idrottsförening och behöver en lagläkare?
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 relative group hover:shadow-xl transition-all duration-300 border border-primary/10">
            <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            
            <div className="relative z-10 space-y-10">
              <div className="flex items-center gap-4 justify-center">
                <p className="text-lg md:text-xl text-secondary-foreground/90 leading-relaxed text-center">
                  Vi erbjuder högkvalitativ vård för alla spelare med tillgänglighet 24/7 oavsett vilken typ av besvär det gäller.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-10">
                {features.map((feature, index) => <div key={index} className="flex flex-col items-center gap-5 group">
                    <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 bg-[#ef2c4c]">
                      <feature.icon className="w-8 h-8 md:w-10 md:h-10 text-white" />
                    </div>
                    <div className="text-center space-y-2">
                      <h3 className="text-lg md:text-xl font-medium text-primary-foreground">
                        {feature.title}
                      </h3>
                      <p className="text-sm md:text-base text-secondary-foreground/80">
                        {feature.description}
                      </p>
                    </div>
                  </div>)}
              </div>

              <div className="text-center border-t border-primary/10 pt-8">
                <p className="text-lg md:text-xl text-primary-foreground font-medium group inline-flex items-center gap-3 hover:opacity-80 transition-opacity">
                  Kontakta oss idag för ett skräddarsytt upplägg!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Idrottsforening;
